export default __webpack_public_path__ + "static/media/img-box-1.460f799b.jpg";